import React, { useEffect, useRef, useState } from "react";
import "./ApplicationForm.css";
import "./profileImageUpload.css";

import upload from "./../../Assets/Images/EditProfile/upload.png";
import close from "./../../Assets/Images/EditProfile/close.png";
import PropertiesService from "../../Services/PropertiesService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import loader from "../../Assets/Images/Loader.gif";
import ProfileImageUpload from "./ProfileImageUpload";
import DocumentPreview from "../Common/DocumentPreview";
import { validateFileSize, normalizeUploadResponse } from "../../utils/uploadUtils";

const CivilProfile = () => {
  const [formError, setFormError] = useState("");
  const [AadharOtpSuccessMessage, setAadharOtpSuccessMessage] = useState("");
  const [AadharOtpVerifyError, setAadharOtpVerifyError] = useState('')
  const [OptSendLoader, setOptSendLoader] = useState(false)
  const fileInputRef = useRef({});
  const [userDetails, setUserDetails] = useState([]);
  const [inputs, setInputs] = useState([{ pincode: "", region: "" }]);
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [university, setUniversity] = useState("");
  const [universityError, setUniversityError] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [monthError, setMonthError] = useState("");
  const [yearError, setYearError] = useState("");
  const [address, setAddress] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [addressError, setAddressError] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [employeeTypeError, setEmployeeTypeError] = useState("");
  const [designation, setDesignation] = useState("");
  const [designationError, setDesignationError] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [officeNameError, setOfficeNameError] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessNameError, setBusinessNameError] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [businessTypeError, setBusinessTypeError] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");
  const [officeLocationError, setOfficeLocationError] = useState("");
  const [numberOfYears, setNumberOfYears] = useState("");
  const [numberOfYearsError, setNumberOfYearsError] = useState("");
  const [age, setAge] = useState("");
  const [ageError, setAgeError] = useState("");
  const [gender, setGender] = useState("");
  const [genderError, setGenderError] = useState("");
  const [govOffice, setGovOffice] = useState("");
  const [govOfficeError, setGovOfficeError] = useState("");
  const [famRef, setFamRef] = useState("");
  const [famRefError, setFamRefError] = useState("");
  const [famRefRelation, setFamRefRelation] = useState("");
  const [famRefRelationError, setFamRefRelationError] = useState("");
  const [famRefPhone, setFamRefPhone] = useState("");
  const [famRefPhoneError, setFamRefPhoneError] = useState("");
  const [famRefAddress, setFamRefAddress] = useState("");
  const [famRefAddressError, setFamRefAddressError] = useState("");
  const [govRefName, setGovRefName] = useState("");
  const [govRefNameError, setGovRefNameError] = useState("");
  const [govRefRel, setGovRefRel] = useState("");
  const [ADHAROtp, setADHAROtp] = useState('');
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadhar, setAadhar] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [AadharOtpError, setAadharOtpError] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [VerifyLoader, setVerifyLoader] = useState(false);
  const [govRefRelError, setGovRefRelError] = useState("");
  const [govRefphone, setGovRefPhone] = useState("");
  const [govRefphoneError, setGovRefPhoneError] = useState("");
  const [govRefAddress, setGovRefAddress] = useState("");
  const [govRefAddressError, setGovRefAddressError] = useState("");
  const [videoDate, setVideoDate] = useState("");
  const [videoDateError, setVideoDateError] = useState("");
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked1Error, setIsChecked1Error] = useState("");
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked2Error, setIsChecked2Error] = useState("");
  const [joinDocity, setJoinDocity] = useState("");
  const [joinDocityError, setJoinDocityError] = useState("");
  const [userImage, setUserImage] = useState("");
  const [uploadedFile, setUploadedFile] = useState([]);
  const [isChecked3, setIsChecked3] = useState(false);
  const [isChecked3Error, setIsChecked3Error] = useState(false);
  // eslint-disable-next-line no-unused-vars -- used in commented approval UI
  const [civilEngineerDetails, setCivilEngineerDetails] = useState([]);
  const [Loading, setLoading] = useState("");
  const [fileUploadErrors, setFileUploadErrors] = useState({});
  const [page, setPage] = useState("page1");
  const navigate = useNavigate();
  const documentTypes = [
    "graduation",
    "Aadhar",
    "dateOfBirth",
    "10Memo",
    "WorkRequest",
    "addressProof",
  ];
  const handleClick = (name) => {
    const input = fileInputRef.current?.[name];
    if (input) {
      input.click();
    }
  };

  const handleFullName = (e) => {
    const value = e.target.value;
    setFullName(value);
    if (!value) {
      setFullNameError("Your Name is required");
    } else {
      setFullNameError("");
    }
  };
  const handleUniversity = (e) => {
    const value = e.target.value;
    setUniversity(value);
    if (!value) {
      setUniversityError("universityName is required");
    } else {
      setUniversityError("");
    }
  };
  const handleMonth = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 2);
    setMonth(val);

    if (!val) {
      setMonthError("Month is required");
    } else if (val < 1 || val > 12) {
      setMonthError("Enter a valid month (01–12)");
    } else {
      setMonthError("");
    }
  };

  const handleYear = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 4);
    setYear(val);

    const currentYear = new Date().getFullYear();

    if (val.length < 4) {
      setYearError("Year must be 4 digits");
    } else if (val < 1900 || val > currentYear) {
      setYearError(`Enter year between 1900 and ${currentYear}`);
    } else {
      setYearError("");
    }
  };

  const handleEmployeeType = (e) => {
    const value = e.target.value;
    setEmployeeType(value);
    if (!value) {
      setEmployeeTypeError("select your Employee Type it is mandatory");
    } else {
      setEmployeeTypeError("");
    }
  };
  const handleDesignation = (e) => {
    const val = normalizeText(
      e.target.value.replace(/[^A-Za-z\s]/g, "")
    );

    setDesignation(val);

    if (!val.trim()) setDesignationError("Designation is required");
    else setDesignationError("");
  };


  const handleOfficeName = (e) => {
    const val = normalizeText(e.target.value);
    setOfficeName(val);

    if (!val) setOfficeNameError("Organization name is required");
    else setOfficeNameError("");
  };


  const handleBusinessName = (e) => {
    const val = normalizeText(e.target.value);
    setBusinessName(val);

    if (!val) setBusinessNameError("Business Name is required");
    else setBusinessNameError("");
  };

  const handlebusinessType = (e) => {
    const val = normalizeText(e.target.value);
    setBusinessType(val);

    if (!val) setBusinessTypeError("Business type is required");
    else setBusinessTypeError("");
  };


  const handleOfficeLocation = (e) => {
    const val = normalizeText(e.target.value);
    setOfficeLocation(val);

    if (!val) setOfficeLocationError("Business address is required");
    else setOfficeLocationError("");
  };

  const handleNumberOfYears = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 2);
    setNumberOfYears(val);

    if (!val) setNumberOfYearsError("Years of business is required");
    else if (val > 80) setNumberOfYearsError("Max allowed is 80 years");
    else setNumberOfYearsError("");
  };


  const handleGovOffice = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 6);

    setGovOffice(val);

    if (!val) {
      setGovOfficeError("Pincode is required");
    }
    else if (val.length !== 6) {
      setGovOfficeError("Pincode must be exactly 6 digits");
    }
    else if (/^0{6}$/.test(val)) {
      setGovOfficeError("Pincode cannot be all zeros");
    }
    else {
      setGovOfficeError("");
    }
  };

  const handleAge = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 3);

    setAge(val);
    if (!val) {
      setAgeError("Age is required");
    }
    else if (val < 18 || val > 100) {
      setAgeError("Age must be between 18 and 100");
    }
    else {
      setAgeError("");
    }
  };

  const handleGender = (e) => {
    const value = e.target.value;
    setGender(value);
    if (!value) {
      setGenderError("Pick you gender it is required");
    } else {
      setGenderError("");
    }
  };
  const handleFamRef = (e) => {
    const value = e.target.value;
    setFamRef(value);
    if (!value) {
      setFamRefError("The Family(or)Friend Referrence Name is required");
    } else {
      setFamRefError("");
    }
  };
  const handleFamRefRelation = (e) => {
    const value = e.target.value;
    setFamRefRelation(value);
    if (!value) {
      setFamRefRelationError(
        "The Family(or)Friend Referrence Relation is required"
      );
    } else {
      setFamRefRelationError("");
    }
  };
  const handleFamRefAddress = (e) => {
    const value = e.target.value;
    setFamRefAddress(value);
    if (!value) {
      setFamRefAddressError(
        "The Family(or)Friend Referrence Address is required"
      );
    } else {
      setFamRefAddressError("");
    }
  };
  const handleFamRefPhone = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setFamRefPhone(value);

    if (!value) {
      setFamRefPhoneError("Reference phone number is required");
    }
    else if (!/^[6-9]\d{9}$/.test(value)) {
      setFamRefPhoneError("Enter a valid 10-digit mobile number");
    }
    else if (/^0{10}$/.test(value)) {
      setFamRefPhoneError("Phone number cannot be all zeros");
    }
    else {
      setFamRefPhoneError("");
    }
  };

  const handleGovRefName = (e) => {
    const value = e.target.value;
    setGovRefName(value);
    if (!value) {
      setGovRefNameError("The Government Officer Referrence Name is required");
    } else {
      setGovRefNameError("");
    }
  };
  const handleGovRefRel = (e) => {
    const value = e.target.value;
    setGovRefRel(value);
    if (!value) {
      setGovRefRelError(
        "The Government Officer Referrence Relation is required"
      );
    } else {
      setGovRefRelError("");
    }
  };
  const handleGovRefPhone = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setGovRefPhone(value);

    if (!value) {
      setGovRefPhoneError("Government reference phone number is required");
    }
    else if (!/^[6-9]\d{9}$/.test(value)) {
      setGovRefPhoneError("Enter a valid 10-digit mobile number");
    }
    else if (/^0{10}$/.test(value)) {
      setGovRefPhoneError("Phone number cannot be all zeros");
    }
    else {
      setGovRefPhoneError("");
    }
  };

  const handleGovRefAddress = (e) => {
    const value = e.target.value;
    setGovRefAddress(value);
    if (!value) {
      setGovRefAddressError(
        "The Government Officer Referrence Address is required"
      );
    } else {
      setGovRefAddressError("");
    }
  };
  const handleVideoDate = (e) => {
    const value = e.target.value;
    setVideoDate(value);

    if (!value) {
      setVideoDateError("Video tutorial date is required");
      return;
    }

    const selectedDate = new Date(value);
    const now = new Date();

    const maxDate = new Date();
    maxDate.setFullYear(now.getFullYear() + 1);

    if (selectedDate <= now) {
      setVideoDateError("Please select a future date and time");
    } else if (selectedDate > maxDate) {
      setVideoDateError("Please select a date within the next year");
    } else {
      setVideoDateError("");
    }
  };

  const handleCheckbox1Change = (e) => {
    const value = e.target.checked;
    setIsChecked1(value);
    if (value === false) {
      setIsChecked1Error(
        "Check the box whether you are willing to join with docity"
      );
    } else {
      setIsChecked1Error("");
    }
  };
  const handleCheckbox2Change = (e) => {
    const value = e.target.checked;
    setIsChecked2(value);
    if (value === false) {
      setIsChecked2Error(
        "Check the box whether you are intrested in vide Tutorial"
      );
    } else {
      setIsChecked2Error("");
    }
  };
  const todayStr = new Date().toISOString().slice(0, 16);
  const nextYearDate = new Date();
  nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
  const maxDateStr = nextYearDate.toISOString().slice(0, 16);
  const handleCheckbox3Change = (e) => {
    const value = e.target.checked;
    setIsChecked3(value);
    if (value === false) {
      setIsChecked3Error(
        "You have to acknowledge the docity conditions by checking the box"
      );
    } else {
      setIsChecked3Error("");
    }
  };
  const handleJoinDocity = (e) => {
    const value = e.target.value;
    setJoinDocity(value);
    if (!value) {
      setJoinDocityError("You have to pick one option");
    } else {
      setJoinDocityError("");
    }
  };
  const handleFileUpload = async (e, name) => {
    const file = e.target.files[0];
    if (!file) return;

    const sizeError = validateFileSize(file);
    if (sizeError) {
      toast.error(sizeError);
      setFileUploadErrors((prev) => ({
        ...prev,
        [name]: sizeError,
      }));
      e.target.value = "";
      return;
    }

    setFileUploadErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    const formData = new FormData();
    formData.append("image", file);
    setLoading(name);
    try {
      const response = await PropertiesService.UploadFiles(formData);
      const fileUrl = normalizeUploadResponse(response);

      if (!fileUrl) {
        const errorMsg = "Upload failed. Please try again.";
        toast.error(errorMsg);
        setFileUploadErrors((prev) => ({ ...prev, [name]: errorMsg }));
        return;
      }

      if (name === "User Image") {
        setUserImage(fileUrl);
      } else {
        setUploadedFile((prevFiles) => [
          ...prevFiles,
          { docName: name, url: fileUrl },
        ]);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      const message = error?.message || "File upload failed";
      toast.error(message);
      setFileUploadErrors((prev) => ({
        ...prev,
        [name]: message,
      }));
    } finally {
      setLoading("");
      // allow selecting same file again
      e.target.value = "";
    }
  };
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userDetails"));
    setUserDetails(data);
    setFullName(data.name);
    getCivilEngineer(data.civilEng_id);
  }, []);
  const getCivilEngineer = async (id) => {
    let obj = { userId: id };
    const response = await PropertiesService.getCivilEngineer(obj);

    const data = response?.data?.data;
    setCivilEngineerDetails(data);

    if (data?.image) {
      setUserImage(data.image);
    }
    if (data?.docs?.length) {
      setUploadedFile(data.docs);
    }
  };

  const updateEngineerDetails = async (e) => {
    e.preventDefault();
    setFormError("");
    let errors = {};
    if (!fullName.trim()) {
      errors.fullName = "Full name is required";
    }
    if (!university.trim()) {
      errors.university = "University name is required";
    }
    if (!age || isNaN(age) || age < 18) {
      errors.age = "Valid age (18+) is required";
    }
    if (!gender) {
      errors.gender = "Gender is required";
    }
    if (!month || !year) {
      errors.passedOutYear = "Month and Year are required";
    }
    if (!address.trim()) {
      errors.address = "Address is required";
    }
    if (!govOffice || !/^\d{6}$/.test(govOffice)) {
      errors.govOffice = "Valid 6-digit pincode is required";
    }
    if (!employeeType.trim()) {
      errors.employeeType = "Occupation is required";
    }
    if (!inputs || inputs.length === 0) {
      errors.inputs = "At least one preferred region is required";
    } else {
      inputs.forEach((input, index) => {
        if (!input.region || !input.pincode || !/^\d{6}$/.test(input.pincode)) {
          errors[
            `region_${index}`
          ] = `Valid region and 6-digit pincode required at row ${index + 1}`;
        }
      });
    }
    if (!famRef || !famRefRelation || !famRefPhone || !famRefAddress) {
      errors.famRef = "All family reference details are required";
    } else if (!/^\d{10}$/.test(famRefPhone)) {
      errors.famRefPhone = "Family reference phone must be 10 digits";
    }
    if (!govRefName || !govRefRel || !govRefphone || !govRefAddress) {
      errors.govRef = "All government reference details are required";
    } else if (!/^\d{10}$/.test(govRefphone)) {
      errors.govRefPhone = "Government reference phone must be 10 digits";
    }
    if (!uploadedFile || uploadedFile.length === 0) {
      errors.uploadedFile = "At least one document must be uploaded";
    }
    if (!isChecked1) {
      errors.isChecked1 = "Willingness to work must be checked";
    }
    if (!isChecked3) {
      errors.isChecked3 = "You must agree to sincerity and honesty";
    }
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((err) => toast.error(err));
      if (errors) {
        setFormError("Please fill all the required details");
        setTimeout(() => setFormError(""), 3000);
        return;
      }

      return;
    }

    // 1. Create the aggregated Object for ApplicationForm
    const applicationFormObject = {
      name: fullName,
      phoneNumber: userDetails.phoneNumber,
      image: userImage,
      PreferredRegions: inputs,
      WillingnessToWork: isChecked1,
      submit_to_DoCity_with_sincerity_and_honesty: isChecked3,
      videoTutorial: {
        videoTutorial: isChecked2,
        date: videoDate,
        joinning: joinDocity,
      },
      Personal_Details: {
        name: fullName,
        universityName: university,
        passedOutYear: month + "/" + year,
        age: age,
        gender: gender,
        aadharNumber: aadhar
      },
      Personal_Address: {
        address: address,
        pincode: govOffice,
      },
      Office_Address: {
        occupation: employeeType,
        Designation: designation,
        organisationName: officeName,
        bussinessTitle: businessName,
        businessType: businessType,
        bussinessAddress: officeLocation,
        years: numberOfYears,
      },
      FamilyHistory: {
        reference1: {
          name: famRef,
          relation: famRefRelation,
          phone: famRefPhone,
          address: famRefAddress,
        },
        reference2: {
          name: govRefName,
          relation: govRefRel,
          phone: govRefphone,
          address: govRefAddress,
        },
      },
      docs: uploadedFile,
      SRO_TYPE: ""
    };

    // 2. Prepare the payload
    let obj = {
      userId: userDetails.civilEng_id,
      name: fullName,
      phoneNumber: userDetails.phoneNumber,
      image: userImage,
      docs: uploadedFile,
      WillingnessToWork: isChecked1,
      submit_to_DoCity_with_sincerity_and_honesty: isChecked3,
      Personal_Details: {
        name: fullName,
        universityName: university,
        passedOutYear: month + "/" + year,
        age: age,
        gender: gender,
        aadharNumber: aadhar
      },
      Personal_Address: {
        address: address,
        pincode: govOffice,
      },
      Office_Address: {
        occupation: employeeType,
        Designation: designation,
        organisationName: officeName,
        bussinessTitle: businessName,
        businessType: businessType,
        bussinessAddress: officeLocation,
        years: numberOfYears,
      },
      videoTutorial: {
        videoTutorial: isChecked2,
        date: videoDate,
        joinning: joinDocity,
      },
      PreferredRegions: inputs,
      FamilyHistory: {
        reference1: {
          name: famRef,
          relation: famRefRelation,
          phone: famRefPhone,
          address: famRefAddress,
        },
        reference2: {
          name: govRefName,
          relation: govRefRel,
          phone: govRefphone,
          address: govRefAddress,
        },
      },
      SRO_TYPE: "",
      // 3. Add ApplicationForm stringified
      ApplicationForm: applicationFormObject
    };

    const response = await PropertiesService.editCivilEngineer(obj);
    if (response?.data?.message === "Success") {
      localStorage.setItem("Admission", "Yes");
      toast.success("The Civil Engineer Admission is Successfully Submited");
      navigate("/navbar/post-submission");
      setTimeout(() => {
        navigate("/navbar/post-submission");
      }, 1000);
    } else {
      toast.success("The Civil Engineer Admission is Failed! please try again");
    }
  };
  const [Error, setError] = useState('')
  const isFutureDateTime = (value) => {
    if (!value) return false;
    return new Date(value) > new Date();
  };

  const nextPage = () => {
    let errors = {};

    if (page === "page1") {
      if (!fullName.trim()) errors.fullName = "Full name is required";
      if (!userImage) errors.userImage = "Profile image is required";
      if (!university.trim()) errors.university = "University name is required";
      if (!month || !year) errors.passedOutYear = "Month and Year are required";
      if (!aadhar) errors.passedOutYear = "Aadhar is required";
      // if (aadharError) errors.passedOutYear = aadharError;
      // if (AadharOtpError) errors.passedOutYear = AadharOtpError;
      const today = new Date().getFullYear();
      const yeardata = year
      if (!month || !year)
        errors["Personal_Details.passedOutYear"] = "Passed out year is required";
      else if (yeardata > today)
        errors["Personal_Details.passedOutYear"] = "Date cannot be in the future";

    }

    if (page === "page2") {
      let errors = [];

      if (!employeeType) errors.push("Select occupation type");

      if (employeeType === "salaried") {
        if (!designation) errors.push("Designation is required");
        if (!officeName) errors.push("Organization name is required");
      }

      if (employeeType === "selfEmployed") {
        if (!businessName) errors.push("Business title is required");
        if (!businessType) errors.push("Business type is required");
        if (!officeLocation) errors.push("Business address is required");
        if (!numberOfYears || numberOfYears > 80)
          errors.push("Enter valid years of business");
      }

      if (!address) errors.push("Address is required");
      if (!/^(?!0{6})\d{6}$/.test(govOffice))
        errors.push("Invalid pincode");
      if (!age || age < 18 || age > 100)
        errors.push("Invalid age");
      if (!gender) errors.push("Gender is required");

      if (errors.length > 0) {
        errors.forEach((err) => toast.error(err));
        return;
      }

      setPage("page3");
    }


    if (page === "page3") {
      if (!famRef || !famRefRelation || !famRefPhone || !famRefAddress) {
        errors.ref1 = "All Family/Friend reference details are required";
      }
      else if (!/^[6-9]\d{9}$/.test(famRefPhone)) {
        errors.famRefPhone =
          "Family reference phone must be a valid 10-digit number";
      }

      if (!govRefName || !govRefRel || !govRefphone || !govRefAddress) {
        errors.ref2 = "All Government reference details are required";
      }
      else if (!/^[6-9]\d{9}$/.test(govRefphone)) {
        errors.govRefPhone =
          "Government reference phone must be a valid 10-digit number";
      }

      const nameSame =
        famRef.trim().toLowerCase() === govRefName.trim().toLowerCase();

      const phoneSame = famRefPhone === govRefphone;

      const relationSame =
        famRefRelation.trim().toLowerCase() === govRefRel.trim().toLowerCase();

      const addressSame =
        famRefAddress.trim().toLowerCase() === govRefAddress.trim().toLowerCase();

      if (nameSame || phoneSame || relationSame || addressSame) {
        errors.sameReference =
          "Family/Friend reference and Government reference must be completely different";
      }
    }

    if (page === "page4") {
      if (!isChecked1) {
        errors.isChecked1 = "Willingness to work must be checked";
      }

      if (!isChecked3) {
        errors.isChecked3 = "You must agree to sincerity and honesty";
      }
      if (!videoDate) {
        errors.videoDate = "Please select a date and time for video tutorial";
      } else if (!isFutureDateTime(videoDate)) {
        errors.videoDate = "Please select a future date and time";
      }

      if (!inputs || inputs.length === 0) {
        errors.inputs = "At least one preferred region is required";
      } else {
        inputs.forEach((input, index) => {
          if (
            !input.region?.trim() ||
            !/^(?!0{6})\d{6}$/.test(input.pincode)
          ) {
            errors[`region_${index}`] =
              `Row ${index + 1}: Enter valid region and 6-digit pincode`;
          }
        });
      }

      if (Object.keys(errors).length > 0) {
        Object.values(errors).forEach((err) => toast.error(err));
        return;
      }
    }


    console.log(errors, 'errors')
    if (Object.keys(errors).length > 0) {

      Object.values(errors).forEach((err) => setError(err));
      setTimeout(() => {
        setError('')
      }, 2000)
      return;
    }
    if (page === "page1") setPage("page2");
    else if (page === "page2") setPage("page3");
    else if (page === "page3") setPage("page4");
    else if (page === "page4") setPage("page5");
  };
  const handleAddress = (e) => {
    const val = normalizeText(e.target.value);
    setAddress(val);

    if (!val) setAddressError("Address is required");
    else setAddressError("");
  };


  const normalizeText = (value) =>
    value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "");
  const handleChange = (index, event) => {
    const { name, value } = event.target;

    const updatedInputs = [...inputs];

    if (name === "pincode") {
      const cleanValue = value.replace(/\D/g, "").slice(0, 6);

      updatedInputs[index][name] = cleanValue;
      setInputs(updatedInputs);
      return;
    }

    updatedInputs[index][name] = value.trim();
    setInputs(updatedInputs);
  };


  const handleAddInput = () => {
    setInputs([...inputs, { pincode: "", region: "" }]);
  };
  const handleRemoveInput = (index) => {
    const updatedInputs1 = inputs.filter((_, i) => i !== index);
    setInputs(updatedInputs1);
  };
  const getRequiredImage = (name) => {
    const file = uploadedFile?.find((file) => file.docName === name);
    return file ? file.url : upload;
  };
  const [AadharReferenceId, setAadharReferenceId] = useState('')
  const handleAadharNumber = async (e) => {
    let input = e.target.value.replace(/\D/g, "");
    input = input.slice(0, 12);
    const formatted = input.replace(/(\d{4})(?=\d)/g, "$1 ");

    setAadhar(formatted);
    const rawAadhar = input;
    console.log(formatted, 'rawAadhar')
    const findAadharNumberVerifiedToUser = await PropertiesService.getdoCityUsers()

    const find1 = findAadharNumberVerifiedToUser?.data?.data?.filter((x) => x.aadharNumber === formatted && x.aadharVerification === true)
    if (find1?.length > 0) {
      setAadharError("This Aadhaar number is already verified. Please use a different number.");
    }
    else
      if (!rawAadhar) {
        setAadharError("Aadhar Number Is Invalid");
      } else if (rawAadhar.length !== 12) {
        setAadharError("Aadhar Number Must be 12 Digits");
      }
      else {
        setAadharError("");
        generateAdharOtp(rawAadhar);
      }
  };

  const generateAdharOtp = async (x) => {
    setOptSendLoader(true)
    let obj = {
      aadhaar_number: x,
      consent: 'y',
      reason: "For aadhar verification"
    };

    try {
      const response = await PropertiesService.generateAadharOtp(obj);
      const message = response?.data?.data?.message;
      console.log(message, 'message')

      setAadharReferenceId(response?.data?.data?.reference_id);
      if (message === "OTP sent successfully") {
        setAadharOtpSuccessMessage(message)
        setTimeout(() => {
          setAadharOtpSuccessMessage('')
        }, 2000)
        setOptSendLoader(false)
        setShowOtpModal(true);
        setTimeLeft(600);
      } else {
        setAadharOtpError(message)
        setOptSendLoader(false)
        setTimeout(() => {
          setAadharOtpError('')
        }, 2000)
      }
    } catch (error) {
      setOptSendLoader(false)
      setAadharOtpError("Failed to send OTP");
    }
  };

  const handleAadharOtpChange = (e) => {
    const aadhar = e.target.value
    setADHAROtp(aadhar);
    if (aadhar.length !== 6) {
      setAadharOtpVerifyError("Please enter complete 6-digit OTP");
    } else {
      setAadharOtpVerifyError('')
    }
  };
  const handleVerifyOtp = async () => {
    setVerifyLoader(true)
    if (!ADHAROtp && ADHAROtp.length !== 6) {
      setAadharOtpVerifyError("Please enter complete 6-digit OTP");
      return;
    }
    const obj = {
      reference_id: String(AadharReferenceId),
      otp: ADHAROtp,
    };
    try {
      const response = await PropertiesService.validateAadharOtp(obj);
      if (response?.data?.code === 200) {
        setShowOtpModal(false);
        setADHAROtp('')
        setAadharOtpVerifyError('')
        setVerifyLoader(false)
        setIsAadharVerified(true);
      } else {
        setVerifyLoader(false)
        setAadharOtpVerifyError(response?.data?.data);
      }
    } catch (error) {
      console.error("API Error", error?.response?.data.data || error);
      setAadharOtpVerifyError(error?.response?.data?.data.message || "Something went wrong");
    }
  };
  const closeTheModel = () => {
    setShowOtpModal(false)
    setADHAROtp('')
    setAadharOtpError('')
    setTimeLeft(0)
  }

  const [timeLeft, setTimeLeft] = useState(0); // 10 min

  useEffect(() => {
    if (!showOtpModal || timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, showOtpModal]);


  // Resend handler
  const handleResendOtp = async () => {
    try {
      const formatted = aadhar.replace(/\D/g, "");
      let obj = {
        aadhaar_number: formatted,
        consent: 'y',
        reason: "For aadhar verification"
      };
      console.log(obj, 'obj')
      const response = await PropertiesService.generateAadharOtp(obj);
      console.log(response, 'response2222')
      const message = response?.data?.data?.message;
      if (message === "OTP sent successfully") {
        setTimeLeft(600);
        setAadharOtpSuccessMessage(message)
        setTimeout(() => {
          setAadharOtpSuccessMessage('')
        }, 2000)
      } else {

        setAadharOtpVerifyError(message);
        setTimeout(() => {
          setAadharOtpVerifyError('')
        }, 2000)
      }
    } catch (err) {
      setAadharOtpVerifyError("Error resending OTP");
    }
  };
  return (
    <div className="container-civilEng-Profile">
      <div className="row">
        <div className="col-md-12">
          <div className="profile-form">
            <div className="tab-nav mb-3">
              <div
                className={`tab-item ${page === "page1" ? "active" : ""}`}
                onClick={() => setPage("page1")}
              >
                1. Profile Info
              </div>
              <div
                className={`tab-item ${page === "page2" ? "active" : ""}`}
                onClick={() => setPage("page2")}
              >
                2. Occupation & Address
              </div>
              <div
                className={`tab-item ${page === "page3" ? "active" : ""}`}
                onClick={() => setPage("page3")}
              >
                3. References
              </div>
              <div
                className={`tab-item ${page === "page4" ? "active" : ""}`}
                onClick={() => setPage("page4")}
              >
                4. Consent & Region
              </div>
              <div
                className={`tab-item ${page === "page5" ? "active" : ""}`}
                onClick={() => setPage("page5")}
              >
                5. Documents
              </div>
            </div>

            <form onSubmit={updateEngineerDetails}>
              <h3 className="text-center">Civil Engineer Admission Form</h3>
              {page === "page1" && (
                <>

                  <ProfileImageUpload
                    userImage={userImage}
                    loading={Loading === "User Image"}
                    fileInputRef={fileInputRef}
                    onSelectFile={(e) => handleFileUpload(e, "User Image")}
                  />

                  {fullNameError && (
                    <p className="error">{fullNameError}</p>
                  )}
                  <div className="row">
                    <div className="col-md-12 p-1">
                      <label>Full Name</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Your Full Name"
                        value={fullName}
                        onChange={handleFullName}
                      />
                      {/* <span className="note">(All Letters in Capitals)</span> */}
                      {fullNameError && (
                        <p className="error">{fullNameError}</p>
                      )}
                    </div>
                  </div>
                  <p className="headings">Education Details</p>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>University Name</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter your University Name"
                        value={university}
                        onChange={handleUniversity}
                      />
                      {universityError && (
                        <p className="error">{universityError}</p>
                      )}
                    </div>
                    <div className="col-md-6 row">
                      <label>Passout Year (Mention Month and year)</label>
                      <div className="col-md-5 p-1">
                        <input
                          type="text"
                          className="form-input"
                          placeholder="MM"
                          value={month}
                          onChange={handleMonth}
                          maxLength={2}
                          inputMode="numeric"
                          pattern="[0-9]*"
                        />

                        {monthError && <p className="error">{monthError}</p>}
                      </div>
                      <div
                        className="col-md-1"
                        style={{
                          paddingTop: "10px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        /
                      </div>
                      <div className="col-md-6 p-1">
                        <input
                          type="text"
                          className="form-input"
                          placeholder="YYYY"
                          value={year}
                          onChange={handleYear}
                          maxLength={4}
                          inputMode="numeric"
                          pattern="[0-9]*"
                        />

                        {yearError && <p className="error">{yearError}</p>}
                      </div>
                    </div>
                  </div>
                  <p className="headings">Aadhar Card</p>
                  <div className="aadhar-form-container">
                    <div className="form-field" style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="aadhar-login"
                        placeholder="Enter Your Aadhar Number"
                        value={aadhar}
                        onChange={handleAadharNumber}
                        maxLength={14}
                      />
                      {isAadharVerified && (
                        <span
                          style={{
                            position: "absolute",
                            right: 20,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "green",
                            fontSize: "20px",
                          }}
                        >
                          ✅
                        </span>
                      )}
                    </div>
                    {aadharError ? <p className="error">{aadharError}</p> : <p className="error">{AadharOtpError}</p>}
                    {OptSendLoader && <p className="error">Sending otp...</p>}
                    {Error && <p className="error">{Error}</p>}


                  </div>
                  <div className="row mt-3 setInCenter">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          {formError && (
                            <p
                              className="error"
                              style={{ textAlign: "center" }}
                            >
                              {formError}
                            </p>
                          )}
                          <button
                            type="button"
                            className="btn btn-next"
                            disabled={Loading}
                            onClick={() => nextPage()}
                          >
                            Next
                          </button>
                        </div>
                        <div className="col-md-4"></div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {page === "page2" && (
                <>
                  <h5 className="headings">Present Occupation</h5>
                  <div className="row p-2">
                    <div className="radio-buttons">
                      <label className="custom-radio">
                        <input
                          type="radio"
                          name="employeeType"
                          value="salaried"
                          checked={employeeType === "salaried"}
                          onClick={handleEmployeeType}
                        />
                        <span className="custom-radio-label">Salaried</span>
                      </label>
                      <label className="custom-radio">
                        <input
                          type="radio"
                          name="employeeType"
                          value="selfEmployed"
                          checked={employeeType === "selfEmployed"}
                          onChange={handleEmployeeType}
                        />

                        <span className="custom-radio-label">
                          Self Employed
                        </span>
                      </label>
                      {employeeTypeError && (
                        <p className="error">{employeeTypeError}</p>
                      )}
                    </div>
                  </div>
                  {employeeType === "salaried" ? (
                    <div className="row">
                      <div className="col-md-6 p-1">
                        <label>Designation</label>
                        <input
                          type="text"
                          className="form-input"
                          placeholder="Enter Your Designation"
                          value={designation}
                          onChange={handleDesignation}
                        />
                        {designationError && (
                          <p className="error">{designationError}</p>
                        )}
                      </div>
                      <div className="col-md-6 p-1">
                        <label>Organization Name</label>
                        <input
                          type="text"
                          className="form-input"
                          placeholder="Enter Your Office Name"
                          value={officeName}
                          onChange={handleOfficeName}
                        />
                        {officeNameError && (
                          <p className="error">{officeNameError}</p>
                        )}
                      </div>
                    </div>
                  ) : employeeType === "" ? (
                    <></>
                  ) : (
                    <div>
                      <div className="row">
                        <div className="col-md-6 p-1">
                          <label>Business Title</label>
                          <input
                            type="text"
                            className="form-input"
                            placeholder="Enter Your Business Title"
                            value={businessName}
                            onChange={handleBusinessName}
                          />
                          {businessNameError && (
                            <p className="error">{businessNameError}</p>
                          )}
                        </div>
                        <div className="col-md-6 p-1">
                          <label>Business Type</label>
                          <input
                            type="text"
                            className="form-input"
                            placeholder="Enter Your Business Type"
                            value={businessType}
                            onChange={handlebusinessType}
                          />
                          {businessTypeError && (
                            <p className="error">{businessTypeError}</p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 p-1">
                          <label>Business Address</label>
                          <input
                            type="text"
                            className="form-input"
                            placeholder="Enter Your Office Location"
                            value={officeLocation}
                            onChange={handleOfficeLocation}
                          />
                          {officeLocationError && (
                            <p className="error">{officeLocationError}</p>
                          )}
                        </div>
                        <div className="col-md-6 p-1">
                          <label>How many years for the Busienss</label>
                          <input
                            type="number"
                            className="form-input"
                            placeholder="How many years haven been in Business"
                            value={numberOfYears}
                            onChange={handleNumberOfYears}
                          />
                          {numberOfYearsError && (
                            <p className="error">{numberOfYearsError}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <p className="headings">Personal Address</p>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Address</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Residential Address"
                        value={address}
                        onChange={handleAddress}
                      />
                      {addressError && <p className="error">{addressError}</p>}
                    </div>
                    <div className="col-md-6 p-1">
                      <label>SRO / MRO office pincode</label>
                      <input
                        type="number"
                        className="form-input"
                        placeholder="Enter near by SRO or MRO Office Pincode"
                        value={govOffice}
                        onChange={handleGovOffice}
                      />
                      {govOfficeError && (
                        <p className="error">{govOfficeError}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Age</label>
                      <input
                        type="number"
                        className="form-input"
                        placeholder="Enter your age"
                        value={age}
                        onChange={handleAge}
                      />
                      {ageError && <p className="error">{ageError}</p>}
                    </div>
                    <div className="col-md-6 pt-4">
                      <div className="row">
                        <div className="col-md-4">
                          <h5 className="emp-type">Gender</h5>
                        </div>
                        <div className="radio-buttons col-md-8">
                          <label className="custom-radio">
                            <input
                              type="radio"
                              name="gender"
                              value="male"
                              checked={gender === "male"}
                              onChange={handleGender}
                            />
                            <span className="custom-radio-label">Male</span>
                          </label>
                          <label className="custom-radio">
                            <input
                              type="radio"
                              name="gender"
                              value="female"
                              checked={gender === "female"}
                              onChange={handleGender}
                            />

                            <span className="custom-radio-label">Female</span>
                          </label>
                          {genderError && (
                            <p className="error">{genderError}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {Error && <p className="error">{Error}</p>}
                  <div className="row mt-3 setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page1")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page3" && (
                <>
                  <h3 className="p-2">
                    Reference 1<span>(Relative or Friends)</span>
                  </h3>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Name</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Referrence Name"
                        value={famRef}
                        onChange={handleFamRef}
                      />
                      {famRefError && <p className="error">{famRefError}</p>}
                    </div>
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Relation</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Referrence Relation"
                        value={famRefRelation}
                        onChange={handleFamRefRelation}
                      />
                      {famRefRelationError && (
                        <p className="error">{famRefRelationError}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Referrence Phone Number</label>
                      <input
                        type="number"
                        className="form-input"
                        placeholder="Enter Referrence Phone Number"
                        value={famRefPhone}
                        onChange={handleFamRefPhone}
                      />
                      {famRefPhoneError && (
                        <p className="error">{famRefPhoneError}</p>
                      )}
                    </div>
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Address</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Referrence Address"
                        value={famRefAddress}
                        onChange={handleFamRefAddress}
                      />
                      {famRefAddressError && (
                        <p className="error">{famRefAddressError}</p>
                      )}
                    </div>
                  </div>
                  <h3 className="p-2">
                    Reference 2<span>(Government Officer)</span>
                  </h3>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Name</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Referrence Name"
                        value={govRefName}
                        onChange={handleGovRefName}
                      />
                      {govRefNameError && (
                        <p className="error">{govRefNameError}</p>
                      )}
                    </div>
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Relation</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Relation"
                        value={govRefRel}
                        onChange={handleGovRefRel}
                      />
                      {govRefRelError && (
                        <p className="error">{govRefRelError}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 p-1">
                      <label>Referrence Phone Number</label>
                      <input
                        type="number"
                        className="form-input"
                        placeholder="Enter Referrence Phone Number"
                        value={govRefphone}
                        onChange={handleGovRefPhone}
                      />
                      {govRefphoneError && (
                        <p className="error">{govRefphoneError}</p>
                      )}
                    </div>
                    <div className="col-md-6 p-1">
                      <label>Referrence Person Address</label>
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter Referrence Address"
                        value={govRefAddress}
                        onChange={handleGovRefAddress}
                      />
                      {govRefAddressError && (
                        <p className="error">{govRefAddressError}</p>
                      )}
                    </div>
                  </div>
                  {Error && <p className="error">{Error}</p>}
                  <div className="row mt-3 setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page2")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page4" && (
                <>
                  <div className="d-flex">
                    <div className="p-2 col-md-6">
                      <div className="col-md-6 p-2">
                        <label className="checkbox-container-civilEng-Profile">
                          <input
                            type="checkbox"
                            id="checkbox1"
                            checked={isChecked1}
                            onChange={handleCheckbox1Change}
                          />
                          <span className="checkbox-box"></span>
                          Willing to Join Docity
                        </label>
                        {isChecked1Error && (
                          <p className="error">{isChecked1Error}</p>
                        )}
                      </div>
                      <div className="col-md-6 p-2">
                        <label className="checkbox-container-civilEng-Profile">
                          <input
                            type="checkbox"
                            id="checkbox2"
                            checked={isChecked2}
                            onChange={handleCheckbox2Change}
                          />
                          <span className="checkbox-box"></span>
                          Video Tutorial To be attended
                        </label>
                        {isChecked2Error && (
                          <p className="error">{isChecked2Error}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 pt-5">
                      <label>Date for Video Tutorial</label>

                      <input
                        type="datetime-local"
                        value={videoDate}
                        onChange={handleVideoDate}
                        min={todayStr}
                        max={maxDateStr}
                        className="form-control"
                      />
                      {videoDateError && (
                        <p className="error">{videoDateError}</p>
                      )}
                    </div>
                  </div>
                  <div className="row p-2">
                    <div className="col-md-6">
                      {employeeType === "selfEmployed" ? (
                        <div className="row">
                          <div className="col-md-6">
                            <h5 className="emp-type">Consent to join Docity</h5>
                          </div>
                          <div className="radio-buttons col-md-6">
                            <label className="custom-radio">
                              <input
                                type="radio"
                                name="joinDocity"
                                value="partTime"
                                checked={joinDocity === "partTime"}
                                onChange={handleJoinDocity}
                              />
                              <span className="custom-radio-label">
                                Part Time
                              </span>
                            </label>
                            <label className="custom-radio">
                              <input
                                type="radio"
                                name="joinDocity"
                                value="fullTime"
                                checked={joinDocity === "fullTime"}
                                onChange={handleJoinDocity}
                              />
                              <span className="custom-radio-label">
                                Full Time
                              </span>
                            </label>
                            {joinDocityError && (
                              <p className="error">{joinDocityError}</p>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="col-md-6 pt-3">
                      <label className="checkbox-container-civilEng-Profile">
                        <input
                          type="checkbox"
                          id="checkbox3"
                          checked={isChecked3}
                          onChange={handleCheckbox3Change}
                        />
                        <span className="checkbox-box"></span>
                        Ackowledgement to Signing Content to Docity
                      </label>
                      {isChecked3Error && (
                        <p className="error">{isChecked3Error}</p>
                      )}
                    </div>
                  </div>
                  <h3 className="pt-2">Preferred Regions</h3>
                  <div className="row">
                    <div className="col-md-10">
                      {inputs.map((input, index) => (
                        <div key={index} className="row">
                          <div className="input-group p-1">
                            <div className="col-md-5 p-1">
                              <label>Pincode</label>
                              <input
                                type="text"
                                className="form-input"
                                placeholder="Pincode"
                                name="pincode"
                                value={input.pincode}
                                onChange={(e) => handleChange(index, e)}
                              />
                            </div>
                            <div className="col-md-5 p-1">
                              <label>Region</label>
                              <input
                                type="text"
                                className="form-input"
                                placeholder="Region"
                                name="region"
                                value={input.region}
                                onChange={(e) => handleChange(index, e)}
                              />
                            </div>
                            {inputs.length > 1 && (
                              <img
                                src={close}
                                width={30}
                                alt="Remove"
                                className="pt-2 removeIcon"
                                onClick={() => handleRemoveInput(index)}
                              />
                            )}
                            <div className="col-md-2"></div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="form-group col-md-2">
                      <button
                        type="button"
                        className="btn AddIcon mt-3"
                        onClick={handleAddInput}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  {Error && <p className="error">{Error}</p>}
                  <div className="row mt-3 setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page3")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page5" && (
                <>
                  <h3 className="pt-4">Documents</h3>
                  <div className="row">
                    {documentTypes.map((name) => (
                      <>
                        <div className="col-md-3 p-1" key={name}>
                          <input
                            type="file"
                            id={name}
                            style={{ display: "none" }}
                            ref={(el) => {
                              if (!fileInputRef.current) {
                                fileInputRef.current = {};
                              }

                              if (el) {
                                fileInputRef.current[name] = el;
                              } else {
                                delete fileInputRef.current[name];
                              }
                            }}

                            onChange={(e) => handleFileUpload(e, name)}
                            accept=".pdf"
                          />
                          <div
                            style={{
                              height: 200,
                              borderRadius: 8,
                              overflow: "hidden",
                              position: "relative",
                              opacity: Loading !== "" && Loading !== name ? 0.5 : 1,
                              pointerEvents: Loading !== "" && Loading !== name ? "none" : "auto",
                              transition: "opacity 0.2s",
                            }}
                          >
                            {/* Upload loader overlay */}
                            {Loading === name && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0, left: 0, right: 0, bottom: 0,
                                  zIndex: 20,
                                  background: "rgba(255,255,255,0.88)",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 8,
                                  gap: 8,
                                }}
                              >
                                <img src={loader} alt="Uploading..." style={{ width: 50 }} />
                                <p style={{ margin: 0, fontSize: 13, color: "#0D1B2A", fontWeight: 600 }}>Uploading...</p>
                              </div>
                            )}
                            {getRequiredImage(name) === upload ? (
                              <div
                                className="col-md-12 graduation"
                                style={{
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => handleClick(name)}
                              >
                                <img src={upload} width={50} alt="upload icon" />
                                <p>{`Upload ${name
                                  .replace(/([A-Z])/g, " $1")
                                  .toUpperCase()}`}</p>
                              </div>
                            ) : (
                              <DocumentPreview
                                url={getRequiredImage(name)}
                                width="100%"
                                height="200px"
                                showActions={true}
                              />
                              )
                              }
                          </div>
                          {fileUploadErrors[name] && (
                            <p className="error mt-1">{fileUploadErrors[name]}</p>
                          )}
                        </div>
                      </>
                    ))}
                  </div>

                  <div className="p-3">
                    <h3 className="text-center">References</h3>
                    <div className="reference">
                      {["refrenceGov", "referenceFam"].map((name) => (
                        <div className="col-md-3 p-1" key={name}>
                          <input
                            type="file"
                            id={name}
                            style={{ display: "none" }}
                            ref={(el) => {
                              if (!fileInputRef.current) {
                                fileInputRef.current = {};
                              }
                              if (el) {
                                fileInputRef.current[name] = el;
                              } else {
                                delete fileInputRef.current[name];
                              }
                            }}
                            onChange={(e) => handleFileUpload(e, name)}
                            accept=".pdf"
                          />
                          <div
                            style={{
                              height: 200,
                              borderRadius: 8,
                              overflow: "hidden",
                              position: "relative",
                              opacity: Loading !== "" && Loading !== name ? 0.5 : 1,
                              pointerEvents: Loading !== "" && Loading !== name ? "none" : "auto",
                              transition: "opacity 0.2s",
                            }}
                          >
                            {Loading === name && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0, left: 0, right: 0, bottom: 0,
                                  zIndex: 20,
                                  background: "rgba(255,255,255,0.88)",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 8,
                                  gap: 8,
                                }}
                              >
                                <img src={loader} alt="Uploading..." style={{ width: 50 }} />
                                <p style={{ margin: 0, fontSize: 13, color: "#0D1B2A", fontWeight: 600 }}>Uploading...</p>
                              </div>
                            )}
                            {getRequiredImage(name) === upload ? (
                              <div
                                className="col-md-12 graduation"
                                style={{
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => handleClick(name)}
                              >
                                <img src={upload} width={50} alt="upload icon" />
                                <p>{`Upload ${name
                                  .replace(/([A-Z])/g, " $1")
                                  .toUpperCase()}`}</p>
                              </div>
                            ) : (
                              <DocumentPreview
                                url={getRequiredImage(name)}
                                width="100%"
                                height="200px"
                                showActions={true}
                              />
                              )
                              }
                          </div>
                          {fileUploadErrors[name] && (
                            <p className="error mt-1">{fileUploadErrors[name]}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* {formError && <p className="error text-danger text-center">{formError}</p>}

                                    <div className='submit-details' onClick={updateEngineerDetails}>
                                        <button className='btn'>Submit</button>
                                    </div> */}
                  {Error && <p className="error">{Error}</p>}
                  <div className="row mt-3 setInCenter">
                    {formError && (
                      <div className="col-12">
                        <p className="error" style={{ textAlign: "center", color: 'red' }}>
                          {formError}
                        </p>
                      </div>
                    )}

                    {/* TERMS AND CONDITIONS SECTION */}
                    <div className="col-md-12 mx-auto mb-4">
                      <div className="terms-container" style={{
                      }}>
                        <div className="form-check d-flex align-items-center justify-content-center" style={{
                          padding: '10px',
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          backgroundColor: '#f8fafc'
                        }}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="termsCheckbox"
                            checked={isAgreed}
                            onChange={(e) => setIsAgreed(e.target.checked)}
                            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                          />
                          <label className="form-check-label ms-3" htmlFor="termsCheckbox" style={{ cursor: 'pointer', fontSize: '14px' }}>
                            I have read and agree to the
                            <a
                              href="/#/TermsAndConditions"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#F39C12', fontWeight: '600', textDecoration: 'none', marginLeft: '5px' }}
                            >
                              Terms & Conditions
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btnprev w-100"
                        onClick={() => setPage("page4")}
                      >
                        Previous
                      </button>
                    </div>

                    <div className="col-md-4">
                      <button
                        type="submit"
                        disabled={Loading !== '' || !isAgreed}
                        className={`btn btnSubmit w-100 ${!isAgreed ? 'disabled-btn' : ''}`}
                      >
                        {Loading !== '' ? "Processing..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
            </form>
          </div>
          {/* {
            civilEngineerDetails && civilEngineerDetails.status && civilEngineerDetails.status == 'Approved' ?
            
              :
              <div className="approval-pending">
                <p>
                  Your Approval is pending from Admin, Please contact admin{" "}
                  <a href="mailto:docityhelp@gmail.com">docityhelp@gmail.com</a>
                </p>
              </div>
          } */}
          {showOtpModal && (

            <div className="otp-modal">
              <div className="otp-content">
                <h3>Enter OTP</h3>
                <div className="otp-inputs">
                  <input
                    placeholder="Enter OTP"
                    type="text"
                    className="form-control"
                    value={ADHAROtp}
                    onChange={handleAadharOtpChange}
                  />
                </div>
                {AadharOtpSuccessMessage ? <p className="error">{AadharOtpSuccessMessage}</p> : <p className="error">{AadharOtpVerifyError}</p>}
                <div style={{ textAlign: "end" }}>
                  {timeLeft > 0 ? (
                    <span style={{ color: "#555" }}>
                      Time left: {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
                    </span>
                  ) : (
                    <></>
                    // <button
                    //   type="button"
                    //   className="resend-otp-btn"
                    //   onClick={handleResendOtp}
                    //   style={{ marginTop: '10px', padding: '6px 12px' }}
                    // >
                    //   Resend OTP
                    // </button>
                  )}
                  <span
                    type="button"
                    className="resend-otp-btn"
                    onClick={handleResendOtp}
                    style={{ marginTop: '10px', padding: '6px 12px', color: 'red' }}
                  >
                    Resend OTP
                  </span>
                </div>
                {VerifyLoader && <p className="error">Verifying OTP, please wait...</p>}
                <div className="row setCenterText mt-3">
                  <div className="col-md-3">
                    <button
                      type="button"
                      style={{ width: '100%' }}
                      disabled={VerifyLoader}
                      onClick={closeTheModel}
                    >
                      Close
                    </button>
                  </div>
                  <div className="col-md-3">
                    <button
                      type="button"
                      style={{ width: '100%' }}
                      disabled={AadharOtpError || VerifyLoader}
                      onClick={handleVerifyOtp}
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* } */}
        </div>
      </div>
    </div>
  );
};

export default CivilProfile;